import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import Pagination from "../Pagination/Paginations.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import EntriesSelector from "../Pagination/EntriesSelector";
import "../preloading.css";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const MonthEarlyGoing = () => {
const today = new Date(); // Date object

 const [filters, setFilters] = useState({
  start_date: today,
  end_date: today,
  dept_id: "0",
  action_type: "Fetch",
});


  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const loadingRef = useRef(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  // ✅ Handle Input
  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ Fetch Departments
  const fetchDepartments = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/showdepartment", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      let deptData = [];
      if (Array.isArray(res.data)) deptData = res.data;
      else if (res.data.departments) deptData = res.data.departments;
      else if (res.data.data) deptData = res.data.data;
      else toast.error("Unexpected response from /showdepartment");

      setDepartments(deptData);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ✅ Fetch Monthly Report
  const handleSubmit = async (e) => {
    e.preventDefault();

    // block repeat clicks while a request is already running
    if (loadingRef.current) return;
    loadingRef.current = true;
    setLoading(true);

    try {
     const res = await axios.post(
  API_BASE_URL + "/month_early_going",
  {
    start_date: filters.start_date
      ? filters.start_date.toISOString().split("T")[0]
      : "",
    end_date: filters.end_date
      ? filters.end_date.toISOString().split("T")[0]
      : "",
    dept_id: filters.dept_id,
    action_type: filters.action_type,
  },
  { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
);

      setRecords(res.data.records || []);
      setCurrentPage(1);
      toast.success("Monthly report loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
        toastId: "monthly-early-going-success",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error fetching monthly report", { toastId: "monthly-early-going-error" });
    } finally {
      loadingRef.current = false;
      setLoading(false);
    }
  };

  // ✅ Search + Pagination
  const filteredItems = records.filter((item) =>
    `${item.employee_id}${item.employee_name}${item.department}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <>
      <div className="container-fluid mt-4">

        {/* 🔹 Filter Form */}
        <div className="card shadow-sm mb-4">
          <h6 className="card-header d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
              <path fillRule="evenodd" d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.017-1.694a.5.5 0 1 1 .858.257z"/>
              <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
              <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z"/>
            </svg>
            Monthly Early Going Report
          </h6>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3 align-items-end">
               {/* From Date */}
<div className="col-md-3">
  <label>From Date</label>
  <DatePicker
    selected={filters.start_date}
    onChange={(date) =>
      setFilters({ ...filters, start_date: date })
    }
    maxDate={filters.end_date}
    className="form-control"
    dateFormat="yyyy-MM-dd"
    placeholderText="Select start date"
  />
</div>

{/* To Date */}
<div className="col-md-3">
  <label>To Date</label>
  <DatePicker
    selected={filters.end_date}
    onChange={(date) =>
      setFilters({ ...filters, end_date: date })
    }
    minDate={filters.start_date}
    className="form-control"
    dateFormat="yyyy-MM-dd"
    placeholderText="Select end date"
  />
</div>

                

                {/* Department */}
                <div className="col-md-3">
                  <label htmlFor="dept_id">Department</label>
                  
  <Select
    name="dept_id"
    value={
      departments
        .map((dept) => ({
          value: dept.department_id || dept.id,
          label: dept.department_name,
        }))
        .find((d) => d.value === filters.dept_id) || null
    }
    onChange={(selected) =>
      handleInput({
        target: {
          name: "dept_id",
          value: selected ? selected.value : "0", // same as "All Department"
        },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id || dept.id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All Department"
    className="basic-single"
  />
                </div>

                {/* Submit */}
                <div className="col-md-2">
                  <button type="submit" className="btn btn-primary btn-sm" style={{ height: "38px" }} disabled={loading}>
                    {loading ? "Loading..." : "Get"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* 🔹 Monthly Report Table */}
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2 align-items-center">
              <div
                className="d-flex align-items-center gap-2"
                style={{ width: "auto", minWidth: "220px" }}
              >
                <DownloadButtons data={filteredItems} filename="Monthly_Early_Going_Report" />
              </div>

              <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                <EntriesSelector
                  setEntriesPerPage={setEntriesPerPage}
                  setCurrentPage={setCurrentPage}
                />
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  style={{ width: "200px" }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            {loading ? (
              <div className="d-flex justify-content-center p-5">
                <div className="spinner"></div>
              </div>
            ) : (
              <div className="table-responsive sticky-table-wrap">
                <table className="table table-bordered table-striped sticky-table sticky-head-tint sticky-no-freeze-col">
                  <thead>
                    <tr>
                      <th>Employee ID</th>
                      <th>Employee Name</th>
                      <th>Department</th>
                      <th>No of Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.length > 0 ? (
                      filteredData.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.employee_id}</td>
                          <td>{row.employee_name}</td>
                          <td>{row.department}</td>
                          <td>{row.early_hours}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-danger fw-bold">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MonthEarlyGoing;
